import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { msalConfig } from './authConfig';
import { isAuthBypassed } from './authConfig';
import { AuthProvider } from './contexts/AuthContext';
import './styles/index.css';
import { MsalProvider } from '@azure/msal-react';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ErrorProvider } from './contexts/ErrorContext';

const msalInstance = new PublicClientApplication(msalConfig);

if (isAuthBypassed) {
  // Mock authentication for development
  msalInstance.setActiveAccount({
    homeAccountId: 'mock-home-account-id',
    environment: 'mock-environment',
    tenantId: 'mock-tenant-id',
    username: 'mockuser@domain.com',
    idTokenClaims: {
      name: 'Mock User',
      oid: 'mock-oid',
    },
    localAccountId: '',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <AuthProvider>
          <ErrorProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </ErrorProvider>
        </AuthProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>
);
